import { CSSTransitionGroup } from 'react-transition-group/dist/react-transition-group.js';

export default CSSTransitionGroup;
